module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "账号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getshopUsers($event)
      }
    },
    model: {
      value: (_vm.filters.shopusername),
      callback: function($$v) {
        _vm.$set(_vm.filters, "shopusername", $$v)
      },
      expression: "filters.shopusername"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getshopUsers
    }
  }, [_vm._v("查询账号信息")])], 1), _vm._v(" "), _c('el-form-item', [(_vm.User.UserLevel != 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增账号信息")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.shopusers,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Number",
      "label": "账号",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "账号名称",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Password",
      "label": "账号密码 ",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "UserLevel",
      "label": "账号级别",
      "width": "120",
      "formatter": _vm.formatlevel,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "State",
      "label": "状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.State == 2) ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "medium"
          }
        }, [_vm._v("停用")]) : _vm._e(), _vm._v(" "), (scope.row.State == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "medium"
          }
        }, [_vm._v("启用")]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), (JSON.parse(this.getuserstate()).TenancyId == 0) ? _c('el-table-column', {
    attrs: {
      "label": "变更状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          ref: _vm.shopusers[scope.$index].Id,
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              _vm.SwitchChange(scope.row)
            }
          },
          model: {
            value: (_vm.shopusers[scope.$index].BoolState),
            callback: function($$v) {
              _vm.$set(_vm.shopusers[scope.$index], "BoolState", $$v)
            },
            expression: "shopusers[scope.$index].BoolState"
          }
        })]
      }
    }])
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "400",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.User.Id != scope.row.Id && _vm.User.UserLevel != 0) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.TenancyId == '0' || _vm.TenancyId == null) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.reset(scope.row)
            }
          }
        }, [_vm._v("重置密码")]) : _vm._e(), _vm._v(" "), (_vm.TenancyId == '0' || _vm.TenancyId == null) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.ShowChangeTwo(scope.row)
            }
          }
        }, [_vm._v("重置操作密码")]) : _vm._e(), _vm._v(" "), (_vm.TenancyId == '0' || _vm.TenancyId == null) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.RandomReset(scope.row)
            }
          }
        }, [_vm._v("随机操作密码")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑账号",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号",
      "prop": "Number"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.editForm.Number),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Number", $$v)
      },
      expression: "editForm.Number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号名称"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Name", $$v)
      },
      expression: "editForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号密码",
      "prop": "Password",
      "hidden": ""
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Password),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Password", $$v)
      },
      expression: "editForm.Password"
    }
  })], 1), _vm._v(" "), (_vm.TenancyId > 0 && _vm.TenancyId != null) ? _c('el-form-item', {
    attrs: {
      "label": "账号级别",
      "prop": "UserLevel"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.UserLevel),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "UserLevel", $$v)
      },
      expression: "editForm.UserLevel"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("管理员")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("前台")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 7
    }
  }, [_vm._v("教练")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 6
    }
  }, [_vm._v("财务")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 4
    }
  }, [_vm._v("水质检测员")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 5
    }
  }, [_vm._v("水电检测员")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Remark", $$v)
      },
      expression: "editForm.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增账号",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号",
      "prop": "Number"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Number),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Number", $$v)
      },
      expression: "addForm.Number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Name", $$v)
      },
      expression: "addForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号密码",
      "prop": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Password", $$v)
      },
      expression: "addForm.Password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号级别",
      "prop": "UserLevel"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.UserLevel),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "UserLevel", $$v)
      },
      expression: "addForm.UserLevel"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("管理员")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("前台")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 7
    }
  }, [_vm._v("教练")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 6
    }
  }, [_vm._v("财务")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 4
    }
  }, [_vm._v("水质检测员")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 5
    }
  }, [_vm._v("水电检测员")])], 1)], 1), _vm._v(" "), (_vm.TenancyId == '0' || _vm.TenancyId == null) ? _c('el-form-item', {
    attrs: {
      "label": "门店列表",
      "prop": "ShopId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择门店"
    },
    model: {
      value: (_vm.addForm.ShopId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "ShopId", $$v)
      },
      expression: "addForm.ShopId"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Remark", $$v)
      },
      expression: "addForm.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "0px",
      "padding-right": "0.25em",
      "padding-bottom": "2ex",
      "padding-left": "0px"
    },
    attrs: {
      "title": "修改密码",
      "close-on-click-modal": false,
      "custom-class": ""
    },
    model: {
      value: (_vm.FormVisible),
      callback: function($$v) {
        _vm.FormVisible = $$v
      },
      expression: "FormVisible"
    }
  }, [_c('el-form', {
    ref: "Form",
    attrs: {
      "model": _vm.Form,
      "label-width": "100px",
      "rules": _vm.FormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "NewPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输新密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.NewPwd),
      callback: function($$v) {
        _vm.$set(_vm.Form, "NewPwd", $$v)
      },
      expression: "Form.NewPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "Confirm"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "确认新密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.Confirm),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Confirm", $$v)
      },
      expression: "Form.Confirm"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.FormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetPWD($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "0px",
      "padding-right": "0.25em",
      "padding-bottom": "2ex",
      "padding-left": "0px"
    },
    attrs: {
      "title": "修改操作密码",
      "close-on-click-modal": false,
      "custom-class": ""
    },
    model: {
      value: (_vm.FormVisible2),
      callback: function($$v) {
        _vm.FormVisible2 = $$v
      },
      expression: "FormVisible2"
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输新操作密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.TwoPassword),
      callback: function($$v) {
        _vm.TwoPassword = $$v
      },
      expression: "TwoPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.FormVisible2 = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.ChangeTwo($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7113fc5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ShopManagement/ShopUser.vue
// module id = 1383
// module chunks = 1